import { createSelector } from '@ngrx/store';

import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entityActividadesAdapter, EntityActividadesState } from './entity-actividades.state';

const { selectEntities, selectAll } = entityActividadesAdapter.getSelectors();

export const getError = (state: EntityActividadesState): any => state.error;

export const getIsLoading = (state: EntityActividadesState): boolean =>
  state.isLoading;

export const selectActividadesState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.actividades
);

export const selectAllActividades = createSelector(selectActividadesState, selectAll);

export const selectEntitiesActividades = createSelector(
  selectActividadesState,
  selectEntities
);

export const selectActividadesFromCurrentEmpresa = createSelector(
  selectAllActividades,
  selectCurrentEmpresa,
  (actividades, currentEmpresa) => actividades.filter( a => a.entidad_productiva_id == currentEmpresa.id)
)

export const selectActividadFromCurrentEmpresaByTipoActividad = (tipoActividad: number) => createSelector(
  selectAllActividades,
  selectCurrentEmpresa,
  (actividades, currentEmpresa) => actividades.find(a => a.entidad_productiva_id == currentEmpresa.id &&
    a.tipo_actividad_id == tipoActividad)
)

// MemoizedSelector<object,any>
export const selectActividadesError = createSelector(
  selectActividadesState,
  getError
);

// MemoizedSelector<object,any>
export const selectActividadesIsLoading = createSelector(
  selectActividadesState,
  getIsLoading
);
